"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var fp_1 = (0, tslib_1.__importDefault)(require("lodash/fp"));
function compareObjectByKeys(key, order) {
    if (order === void 0) { order = 'asc'; }
    return function innerSort(a, b) {
        if (!fp_1.default.has(key, a) || !fp_1.default.has(key, b))
            return 0;
        var comparison = a[key].localeCompare(b[key]);
        return order === 'desc' ? comparison * -1 : comparison;
    };
}
exports.default = compareObjectByKeys;
